import React from 'react'
import { capitalCase } from 'change-case'
import { Award, Coins, LucideIcon, Star, Users } from 'lucide-react'

import { Skeleton } from '@rewardops/ui'

import { useApi } from '~/components/hooks/use-api'
import { useFormat } from '~/components/hooks/use-format'
import { PAWSectionType } from './paw-section-types'

export const Overview: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  const { api } = useApi()
  const { formatNumber } = useFormat()

  const { data: overview, isLoading } = api.pawDashboards.getOverview.useQuery({
    role: data?.role,
    ...(content?.metadata?.params ?? {}),
  })

  const iconsMap: Record<string, LucideIcon> = {
    pointsBalance: Coins,
    rank: Users,
    lifetimePointsAwarded: Award,
  }

  return (
    <section
      id={content?.sectionId}
      data-testid={content?.sectionId}
      className="overflow-hidden rounded-xl border border bg-white text-card-foreground shadow-sm"
    >
      <div className="grid grid-cols-1 divide-y divide-border md:grid-cols-3 md:divide-x md:divide-y-0">
        {isLoading
          ? Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} className="h-[200px]" />
            ))
          : Object.keys(overview ?? {})?.length
          ? Object.keys(overview ?? {})?.map((key) => {
              const Icon = iconsMap?.[key] ?? Star

              return (
                <div className="p-6" key={key}>
                  <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                    <Icon className="text-tenant-primary-color" />
                    {capitalCase(key)}
                  </div>
                  <div className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
                    {typeof overview?.[key as keyof typeof overview] ===
                    'number'
                      ? formatNumber(
                          overview?.[key as keyof typeof overview] as number,
                        )
                      : `#${
                          (overview?.[key as keyof typeof overview] as any)
                            ?.rank
                        }`}
                  </div>
                </div>
              )
            })
          : null}
      </div>
    </section>
  )
}
